import type { FC } from "react"
import { FileIcon, type FileIconType } from "shared/assets/icons/FileIcon"

interface FileTypeIconProps {
  fileName: string
  className?: string
}

const EXTENSION_TO_ICON_TYPE: Record<string, FileIconType> = {
  jpeg: "jpeg",
  jpg: "jpg",
  png: "png",
  gif: "gif",
  doc: "doc",
  docx: "doc",
  pdf: "pdf",
}

export const FileTypeIcon: FC<FileTypeIconProps> = ({ fileName, className }) => {
  const extension = fileName.split(".").pop()?.toLowerCase() ?? ""
  const type = EXTENSION_TO_ICON_TYPE[extension] ?? "default"
  return <FileIcon type={type} className={className} />
}
